// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import * as FilestackUrls from "@outschool/filestack-urls";
import { ListingPhoto_ActivityFragment } from "@outschool/gql-frontend-generated";
import { gql } from "@outschool/ui-apollo";
import { SectionRibbon } from "@outschool/ui-components-shared";
import { useDevicePixelRatio, useIsMobile } from "@outschool/ui-utils";
import React from "react";

import LazyImage from "./LazyImage";

type ActivityListingPhotoProps = {
  activity: ListingPhoto_ActivityFragment;
  imageFit?: string;
  useOriginalAspectRatio?: boolean;
  borderRadius?: string;
  onLoad?: () => void;
};

function ActivityListingPhoto({
  activity,
  imageFit,
  useOriginalAspectRatio = false,
  borderRadius = "0.5em",
  ...props
}: ActivityListingPhotoProps) {
  const photo = activity.details.photo;
  let options: { fit?: string; w?: number; h?: number } = { fit: imageFit };
  const isMobile = useIsMobile();
  const pixelRatio = useDevicePixelRatio();
  if (isMobile || useOriginalAspectRatio) {
    options["w"] = 344 * pixelRatio;
    options["h"] = 179 * pixelRatio;
  } else {
    options["w"] = 288 * pixelRatio;
    options["h"] = 180 * pixelRatio;
  }
  return (
    <LazyImage
      renderAsBackground
      style={{
        position: "relative",
        width: "100%",
        paddingBottom: "52%",
        minHeight: useOriginalAspectRatio ? undefined : "180px",
        borderRadius: borderRadius,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: `url(${FilestackUrls.imageUrl(photo, options)})`,
      }}
      {...props}
    />
  );
}
ActivityListingPhoto.fragments = {
  activity: gql`
    fragment ListingPhoto_activity on Activity {
      isClub
      details {
        photo
      }
      ...SectionRibbon_activity
    }
    ${SectionRibbon.fragments.activity}
  `,
};

export default ActivityListingPhoto;
